import animationData from "@/animations/loading.json";
import Player from "lottie-react";

interface LoadingAnimationProps {
  fullScreen?: boolean;
  width?: string;
  height?: string;
}

export const RebuildLoading = ({ fullScreen = true, width = "20%", height = "30%" }: LoadingAnimationProps) => {
  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: fullScreen ? "rgba(0, 0, 0, 0.5)" : "",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Player autoplay loop animationData={animationData} style={{ width, height }} />
    </div>
  );
};
